import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import Collapsible from 'react-collapsible'

import Icon from 'Pods/Shared/Icon/Icon'

function CollapsibleItem({ downloadPath, model, files }) {
  function renderTrigger() {
    return (
      <Fragment>
        <img src={model.thumbnail} alt={model.title} className="model-thumb" />
        {model.title} Model Files
        <a href={downloadPath} className="u-ml10" onClick={(e) => e.stopPropagation()}>
          <Icon type={['fas', 'arrow-alt-to-bottom']} notSpaced />
        </a>
      </Fragment>
    )
  }

  return (
    <Collapsible
      className="Collapsible--grey"
      openedClassName="Collapsible--grey is-opened"
      trigger={renderTrigger()}
      transitionTime={300}
    >
      <ul className="files-list">
        {files.map(file => (
          <li key={file.id}>
            {file.name}
            <span className="u-float-right">
              ({file.size}) <a href={`${downloadPath}&file_id=${file.id}`}>Download</a>
            </span>
          </li>
        ))}
      </ul>
    </Collapsible>
  )
}

CollapsibleItem.propTypes = {
  downloadPath: PropTypes.string.isRequired,
  model: PropTypes.shape({
    thumbnail: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
  files: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      size: PropTypes.string.isRequired,
    })
  ).isRequired,
}

export default CollapsibleItem
